import { render, staticRenderFns } from "./DocResults.vue?vue&type=template&id=153440f0"
import script from "./DocResults.vue?vue&type=script&lang=ts"
export * from "./DocResults.vue?vue&type=script&lang=ts"
import style0 from "./DocResults.vue?vue&type=style&index=0&id=153440f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports